import _ from 'lodash'
import * as Y from 'yjs'
import {ILabel} from '../contexts/labeling'
import {mergeEvents} from './events'

export function writeToLabelTrack(
  labels: Y.Map<ILabel<object> | undefined> | undefined,
  data: ILabel<object>
) {
  const debug = false
  if (!labels) return
  const _prevLabels: {[key: string]: ILabel<object>} = labels.toJSON()
  const _merged: {[key: string]: ILabel<object>} = _.chain(mergeEvents(_.values(_prevLabels), data))
    .map((e) => [e.start, e])
    .fromPairs()
    .value()
  const _indexTimes: number[] = _.chain([_.values(_prevLabels), _.values(_merged), data])
    .flatten()
    .map((v: ILabel<object>) => v.start)
    .filter((v) => v !== undefined)
    .uniq()
    .sort()
    .value()
  if (debug)
    console.log(
      {
        events: _.values(_prevLabels),
        target: data,
        expected: _.values(_merged),
      },
      _indexTimes
    )
  _.forEach(_indexTimes, (t) => {
    const a = _.get(_prevLabels, t)
    const b = _.get(_merged, t)
    if (a) {
      if (!b) {
        if (debug) console.log('deleted', t, a, b)
        labels.delete(_.toString(t))
        return
      }
      if (_.isEqual(a, b)) {
        if (debug) console.log('unchanged', t, a, b)
        return
      }
      if (debug) console.log('changed', t, a, b)
      labels.set(_.toString(b.start), b)
      return
    }
    if (!b) {
      if (debug) console.log('no data for b', t, _merged)
      return
    }
    if (debug) console.log('new', t, a, b)
    labels.set(_.toString(b.start), b)
  })
}
